import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useUserRole() {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const checkRole = useCallback(async () => {
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    try {
      // Read the user's roles directly (avoids ambiguous has_role overloads)
      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .eq('role', 'admin')
        .maybeSingle();
      if (error) {
        console.error('user_roles query error:', error);
        setIsAdmin(false);
      } else {
        setIsAdmin(!!data);
      }

    } catch (e) {
      console.error('Role check failed:', e);
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    // Wait for auth to finish loading before checking role
    if (authLoading) {
      setLoading(true);
      return;
    }

    setLoading(true);
    checkRole();
  }, [user, authLoading, checkRole]);

  // Refresh function to manually re-check role
  const refreshRole = useCallback(() => {
    setLoading(true);
    checkRole();
  }, [checkRole]);

  return { isAdmin, loading, refreshRole };
}
